import React, { useState, useEffect } from 'react';
import {
	Typography,
	Container,
	Grid,
	Box,
	ThemeProvider,
	createTheme,
	IconButton,
	Modal,
	Button,
	TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { HeaderTracking } from '../componentsLanding/HeaderTracking';
import { Link, useLocation } from 'react-router-dom';
import { imgWallpaperPiluLogo } from '../../auth/AuthComponent';

{
	/** Custom theme creation */
}
const theme = createTheme({
	palette: {
		primary: {
			main: '#143F6C',
		},
		secondary: {
			main: '#f50057',
		},
		background: {
			default: '#fff',
		},
		success: {
			main: '#4CAF50',
		},
	},
});

{
	/** Modal component for uploading invoices */
}
const InvoiceUploadModal = ({ open, handleClose }) => (
	<Modal
		open={open}
		onClose={handleClose}
		aria-labelledby='modal-title'
		aria-describedby='modal-description'
	>
		<Box
			sx={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: 400,
				height: 'auto',
				bgcolor: 'background.default',
				borderRadius: '8px',
				boxShadow: 24,
				p: 4,
				overflowY: 'auto',
			}}
		>
			<Box sx={{ position: 'absolute', top: 0, right: 0 }}>
				<IconButton aria-label='close' onClick={handleClose}>
					<CloseIcon />
				</IconButton>
			</Box>
			<Typography
				id='modal-title'
				variant='h6'
				component='h2'
				align='center'
				sx={{ fontSize: '1rem' }}
			>
				Subir factura de pago
			</Typography>
			<Box sx={{ mt: 2 }}>
				<TextField
					fullWidth
					type='file'
					label='Seleccione un archivo'
					InputLabelProps={{
						shrink: true,
					}}
				/>
			</Box>
		</Box>
	</Modal>
);

{
	/** Welcome section component */
}
const WelcomeSection = ({ handleInvoiceModalOpen }) => (
	<Grid
		item
		xs={12}
		md={7}
		sx={{
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			backgroundColor: 'rgba(240, 240, 240, 0.8)',
			padding: '20px',
		}}
	>
		<Typography
			sx={{ fontWeight: 'bolder' }}
			variant='h2'
			component='h1'
			gutterBottom
		>
			¡Relájate y disfruta!
		</Typography>
		<Typography variant='body1' gutterBottom fontSize={23}>
			En PILU, entendemos lo emocionante que es esperar tu pedido.
			Queremos que te sientas tranquilo y seguro de que llegará a ti en el
			momento justo. Mientras esperas, tómate un momento para relajarte y
			disfrutar del proceso.
		</Typography>
		<Box sx={{ display: 'flex', mt: 2 }}>
			<Button
				variant='contained'
				color='primary'
				startIcon={<VisibilityIcon />}
				component={Link}
				to='/tracking/pedidos-tabla'
				sx={{
					mr: 2,
					fontWeight: 'bold',
					'&:hover': { color: 'white' },
				}}
			>
				Ver mis pedidos
			</Button>
			<Button
				variant='contained'
				color='success'
				startIcon={<AttachFileIcon />}
				onClick={handleInvoiceModalOpen}
				sx={{ color: '#fff' }}
				disabled
			>
				Subir factura de pago
			</Button>
		</Box>
	</Grid>
);

{
	/** Background container component */
}
const BackgroundContainer = ({ children }) => (
	<Box
		style={{
			height: '100vh',
			width: '100vw',
			maxHeight: '100%',
			maxWidth: '100%',
			backgroundImage: `url('${imgWallpaperPiluLogo}')`,
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			backgroundPosition: 'center',
		}}
	>
		{children}
	</Box>
);

{
	/** Content container component */
}
const ContentContainer = ({ children }) => (
	<Container
		maxWidth='xl'
		sx={{
			height: '100vh',
			width: '100vw',
			maxHeight: '100%',
			maxWidth: '100%',
		}}
	>
		{children}
	</Container>
);

{
	/** Main component for home tracking page */
}
export const HomeTracking = () => {
	const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
	const { pathname } = useLocation();

	{
		/** Effect to set the last path on pathname change */
	}
	useEffect(() => {
		const path = pathname;
		localStorage.setItem('lastPathPilu', path);
	}, [pathname]);

	const handleInvoiceModalOpen = () => {
		setInvoiceModalOpen(true);
	};

	const handleInvoiceModalClose = () => {
		setInvoiceModalOpen(false);
	};

	return (
		<ThemeProvider theme={theme}>
			<BackgroundContainer>
				<HeaderTracking />
				<ContentContainer>
					<Grid
						container
						spacing={3}
						sx={{
							height: '100%',
							width: '100%',
							margin: '40px 0 0 0',
						}}
					>
						<WelcomeSection
							handleInvoiceModalOpen={handleInvoiceModalOpen}
						/>
					</Grid>
				</ContentContainer>
				<InvoiceUploadModal
					open={invoiceModalOpen}
					handleClose={handleInvoiceModalClose}
				/>
			</BackgroundContainer>
		</ThemeProvider>
	);
};
